export default {
    orderList: [
        {
            id: 1,
            name: '蓝瓶咖啡线下体验店室内设计1',
            state: '进行中',
            level: 'high',
        },
        {
            id: 2,
            name: '双12投放 Banner',
            state: '进行中',
            level: 'high',
        },
        {
            id: 3,
            name: 'Global 大促活动',
            state: '进行中',
            level: 'high',
        },
        {
            id: 4,
            name: 'Banner 拓展',
            state: '进行中',
            level: 'middle',
        },
        {
            id: 5,
            name: '类目市场宣传设计',
            state: '待处理',
            level: 'low',
        },
        {
            id: 6,
            name: '类目市场宣传设计',
            state: '待处理',
            level: 'low',
        },
        {
            id: 7,
            name: '类目市场宣传设计',
            state: '待处理',
            level: 'low',
        },
    ],
    timeLineList: [
        {
            planName: '财经周会',
            planAddress: '深圳 T4-4-1；杭州 7-4-9-N',
            planTime: '09:00',
            planDuaring: '2小时',
        },
        {
            planName: '财经周会',
            planAddress: '深圳 T4-4-1；杭州 7-4-9-N',
            planTime: '11:00',
            planDuaring: '2小时',
        },
    ],
    projectList: [
        {
            projectId: 1,
            projectName: 'Alibaba ICS 研发',
            projectDesc: '一站式设计协作管理平台',
            createTime: '2019-11-12',
            update: '莉莉 2小时前',
            img: 'https://img.alicdn.com/tfs/TB1JLwHvHj1gK0jSZFOXXc7GpXa-200-200.png',
        },
        {
            projectId: 2,
            projectName: '计件平台研发管理',
            projectDesc: '面向全集团各业务部门的外包设计及管理服务',
            createTime: '2019-11-12',
            update: '钉钉 2小时前',
            img: 'https://img.alicdn.com/tfs/TB1533CvKL2gK0jSZPhXXahvXXa-200-200.png',
        },
        {
            projectId: 3,
            projectName: '素材中心研发管理',
            projectDesc: '集团统一的素材管理平台',
            createTime: '2019-11-12',
            update: '默默 2天前',
            img: 'https://img.alicdn.com/tfs/TB1IfwHvHj1gK0jSZFOXXc7GpXa-200-200.png',
        },
        {
            projectId: 4,
            projectName: '设计服务平台管理',
            projectDesc: '从需求、缺陷、迭代的管理到统一的报告一应俱全',
            createTime: '2019-11-12',
            update: '钉钉 2小时前',
            img: 'https://img.alicdn.com/tfs/TB15twFvQY2gK0jSZFgXXc5OFXa-200-200.png',
        },
        {
            projectId: 5,
            projectName: 'Alibaba XiNiu Survey',
            projectDesc: '一站式用户主观数据分析平台',
            createTime: '2019-11-12',
            update: '默默 2天前',
            img: 'https://img.alicdn.com/tfs/TB1InwHvQT2gK0jSZFkXXcIQFXa-200-200.png',
        },
    ],
    updateList: [
        {
            projectItem: 'Fusion Design',
            project: '设计中台',
            time: '4小时前',
            name: '阮小五',
            action: 'create',
            avatar: 'https://img.alicdn.com/tfs/TB1corrvHr1gK0jSZFDXXb9yVXa-500-500.png',
        },
        {
            projectItem: 'ICS Design',
            project: '设计中台',
            time: '4小时前',
            name: '樊瑞',
            action: 'create',
            avatar: 'https://img.alicdn.com/tfs/TB1uD_svKH2gK0jSZFEXXcqMpXa-500-500.png',
        },
        {
            projectItem: 'Fusion Design',
            project: '设计中台',
            time: '4小时前',
            name: '李力',
            action: 'release',
            avatar: 'https://img.alicdn.com/tfs/TB12knwvHj1gK0jSZFuXXcrHpXa-500-500.png',
        },
        {
            projectItem: 'Done',
            project: '设计服务平台',
            time: '4小时前',
            name: '公孙胜',
            action: 'create',
            avatar: 'https://img.alicdn.com/tfs/TB1aD_svKH2gK0jSZFEXXcqMpXa-500-500.png',
        },
        {
            projectItem: '留言',
            project: '设计中台',
            time: '4小时前',
            name: '阮小七',
            action: 'note',
            avatar: 'https://img.alicdn.com/tfs/TB13djnvGL7gK0jSZFBXXXZZpXa-500-500.png',
        },
    ],
    entrances: [
        {
            name: '操作一',
            link: '/',
        },
        {
            name: '操作二',
            link: '/',
        },
        {
            name: '操作三',
            link: '/',
        },
        {
            name: '操作四',
            link: '/',
        },
        {
            name: '操作五',
            link: '/',
        },
        {
            name: '操作六',
            link: '/',
        },
        {
            name: '操作七',
            link: '/',
        },
        {
            name: '操作八',
            link: '/',
        },
    ],
};
